import { Action, createSelector, Selector, State, StateContext } from '@ngxs/store';
import { DefaultOrderCreated, FetchOrderSuccess, UpdateCurrentStep } from '../pages/orders/modules/order/state/actions/order.actions';
import { OrderStepCode } from '../pages/orders/modules/order/enums/order-step-code.enum';
import { OrderDto } from '../pages/orders/modules/order/models/order-dto';
import { Injectable } from '@angular/core';
import { ResetOrderLastVisitedStep } from 'src/app/states/order-last-visited-step.actions';
import { RouterNavigated } from '@ngxs/router-plugin';

interface OrderLastVisitedStepStateModel {
  lastVisitedStep: OrderStepCode;
  orderId: OrderDto['id'] | null;
}

// ngxs storage plugin ver. 3.8 doesn't support feature modules, so it's not possible to add keeping OrderStepsState in the sessionStorage
// in the feature module
@State<OrderLastVisitedStepStateModel>({
  name: 'orderLastVisitedStep'
})
@Injectable()
export class OrderLastVisitedStepState {
  public static lastVisitedStep(orderId: OrderDto['id']): (state: OrderLastVisitedStepStateModel) => OrderStepCode | null {
    return createSelector([OrderLastVisitedStepState], (state: OrderLastVisitedStepStateModel): OrderStepCode | null => {
      return state.orderId === orderId ? state.lastVisitedStep : null;
    });
  }

  @Selector([OrderLastVisitedStepState])
  public static orderId(state: OrderLastVisitedStepStateModel): OrderDto['id'] | null {
    return state.orderId;
  }

  @Selector([OrderLastVisitedStepState])
  public static lastVisitedStepValue(state: OrderLastVisitedStepStateModel): OrderStepCode {
    return state.lastVisitedStep;
  }

  @Action(UpdateCurrentStep)
  public updateCurrentStep(ctx: StateContext<OrderLastVisitedStepStateModel>, { step }: UpdateCurrentStep): void {
    ctx.patchState({ lastVisitedStep: step });
  }

  @Action(FetchOrderSuccess)
  public fetchOrderSuccess(ctx: StateContext<OrderLastVisitedStepStateModel>, { order }: FetchOrderSuccess): void {
    ctx.patchState({ orderId: order.id });
  }

  @Action(DefaultOrderCreated)
  public createNewOrder(ctx: StateContext<OrderLastVisitedStepStateModel>, { order }: DefaultOrderCreated): void {
    ctx.patchState({ orderId: order.id, lastVisitedStep: OrderStepCode.Demographics });
  }

  @Action(ResetOrderLastVisitedStep)
  public resetLastVisitedStep(ctx: StateContext<OrderLastVisitedStepStateModel>): void {
    ctx.setState({ orderId: null, lastVisitedStep: OrderStepCode.Demographics });
  }

  @Action(RouterNavigated<unknown>)
  public manageClearingLastVisitedStep(ctx: StateContext<OrderLastVisitedStepStateModel>, { event }: RouterNavigated<unknown>): void {
    const orderId = ctx.getState().orderId;
    if (orderId === null) {
      return;
    }
    if (!event.url.includes(`/orders/${orderId}`)) {
      ctx.setState({ orderId: null, lastVisitedStep: OrderStepCode.Demographics });
      return;
    }
  }
}
